// src/components/TimelineView.js

import React from "react";
import "./TimelineView.css";

const parseYear = (dateStr = "") => {
  // Handles: "December, 2025", "Sep 2024", "2025", "Jan 2019", "Jul, 2022 – Nov, 2022"
  const m = dateStr.match(/\b(20\d{2}|19\d{2})\b/g);
  if (!m) return "";
  // If multiple years (ranges), return the latest for sorting, first for display
  return m[m.length - 1];
};

const sortByDateDesc = (items, getDate) =>
  [...items].sort((a, b) => {
    const ya = parseInt(parseYear(getDate(a))) || 0;
    const yb = parseInt(parseYear(getDate(b))) || 0;
    // "present" items sort to top
    const aPresent = /present/i.test(getDate(a));
    const bPresent = /present/i.test(getDate(b));
    if (aPresent && !bPresent) return -1;
    if (!aPresent && bPresent) return 1;
    return yb - ya;
  });

const TimelineView = ({ items, getDate, accentColor = "#e86c2f", renderCard }) => {
  const sorted = sortByDateDesc(items, getDate);
  const years = sorted.map(item => parseYear(getDate(item)));
  const mostRecentYear = years[0];

  return (
    <div className="tl-view">
      <div className="tl-view__line" style={{ background: accentColor, opacity: 0.25 }} />
      {sorted.map((item, i) => {
        const year = years[i];
        const isRecent = year === mostRecentYear || /present/i.test(getDate(item));
        return (
          <div key={item.id || i} className="tl-view__item">
            <div
              className={`tl-view__dot${isRecent ? " tl-view__dot--filled" : ""}`}
              style={isRecent
                ? { background: accentColor, borderColor: accentColor }
                : { borderColor: accentColor }}
            />
            <div className="tl-view__year" style={{ color: accentColor }}>
              {/present/i.test(getDate(item)) ? "Present" : getDate(item)}
            </div>
            <div className="tl-view__card">
              {renderCard(item)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TimelineView;